import styled from 'styled-components';

import { getBrandImage } from '@utils/get-brand-image';

import { BREAKPOINTS } from '@shared/styled-system';

const prefooterBG = getBrandImage('prefooterBg');

export const Wrapper = styled.div`
	position: relative;
	background-repeat: no-repeat;
	background-size: cover;
	margin-top: 50px;
	padding: 0 40px;

	background-image: url('${prefooterBG}');
	background-repeat: no-repeat;
	background-position: bottom;
	background-size: cover;
	border-radius: 8px;
`;

export const Section = styled.div`
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;

	@media (max-width: 992px) {
		flex-direction: column;
	}
`;
export const Group = styled.div`
	max-width: 550px;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: baseline;
	gap: 20px;

	@media (max-width: 992px) {
		align-items: center;
		width: 100%;
		margin-top: 25px;
	}
`;
export const Title = styled.h3`
	font-weight: 800;
	font-size: 56px;
	letter-spacing: 0.02em;
	text-align: left;
	color: ${({ theme }) => theme.colors.text.title};

	@media (max-width: 992px) {
		font-size: 32px;
		text-align: center;
	}
`;

export const DescGroup = styled.div`
	display: flex;
	flex-direction: column;

	@media (max-width: 992px) {
		text-align: center;
	}
`;
export const Desc = styled.div`
	font-weight: 700;
	font-size: 20px;
	color: ${({ theme }) => theme.colors.text.subtitle};

	@media (max-width: 992px) {
		font-size: 16px;
	}
`;

export const ButtonWrapper = styled.div`
	margin-top: 20px;
`;

export const ImgWrapper = styled.div`
	width: 100%;
	max-width: 580px;
	max-height: 504px;
	display: flex;
	padding-top: 10px;
`;

export const Img = styled.img`
	@media (${BREAKPOINTS.SMALL_DESKTOP}) {
		width: 100%;
		margin-top: 25px;
	}
`;
